import makeStyles from '@mui/styles/makeStyles';
import {
  flexAlignCenterJustifySpaceBetween,
  flexColumnAlignCenterJustifySpaceAround,
} from 'src/helpers/StyleUtilities';

const useStyles = makeStyles(() => ({
  markersTop: {
    ...flexColumnAlignCenterJustifySpaceAround,
    minHeight: 320,
  },
  pressFields: {
    ...flexAlignCenterJustifySpaceBetween,
    '&  button:nth-child(2)': {
      marginRight: 12,
    },
  },
  textFields: {
    marginRight: 12,
  },
  inAndOutButton: {
    minWidth: 'auto',
  },
  markersButtons: {
    ...flexAlignCenterJustifySpaceBetween,
    width: '100%',
  },
  markersRemoveButton: {
    marginLeft: 10,
  },
  markersListTitle: {
    fontSize: 24,
    width: '100%',
    textAlign: 'left',
    marginTop: 20,
  },
}));

export default useStyles;
